'use client';

import type { Dictionary, Locale } from './types';
import { useLocale } from './context';
import esDictionary from './dictionaries/es';
import enDictionary from './dictionaries/en';

const DICTIONARIES: Record<Locale, Dictionary> = {
  es: esDictionary,
  en: enDictionary,
};

export function useTranslations() {
  const { locale } = useLocale();
  const dict = DICTIONARIES[locale] ?? DICTIONARIES.es;

  function t<K extends keyof Dictionary>(namespace: K): Dictionary[K] {
    return dict[namespace];
  }

  return { t, locale, isLoading: false as const };
}
